import React from 'react';
import {TagOutlined} from '@/icons';
import {Tag} from 'antd';

const columnDefines = () => ({
    groupName: {
        title: '标签组名称',
        dataIndex: 'groupName',
    },
    tags: {
        title: '标签',
        dataIndex: 'tagList',
        render: tags => (
            <>
                {tags.map(tag => {
                    return (
                        <Tag icon={<TagOutlined />} key={tag.id}>
                          {tag.tagName}
                        </Tag>
                      );
                })}
            </>
        ),
    },
});


export function getColumns(keys) {
    const defines = columnDefines();
    return keys.map(key => defines[key]).filter(Boolean);
}
